export const getCollectionV2QueryKey = {
	all: ['collection/v2'],
	asset_id: () => [...getCollectionV2QueryKey.all, 'asset_id'],
	asset_param: params => [...getCollectionV2QueryKey.asset_id(), { ...params }],
}

export const getDeclineHistoryQueryKey = {
	all: ['activity_id', 'activity_type_id', 'activity_type_category_id'],
	activity_param: params => [...getDeclineHistoryQueryKey.all, { ...params }],
}

export const searchOrgContactsQueryKey = {
	all: ['search_string'],
	search_string_param: params => [
		...searchOrgContactsQueryKey.all,
		{ ...params },
	],
}
